import { useEffect } from 'react';

import { addDataEvent, EventAttributes } from '@creditornot/browser-telemetry';

export type WarehouseSearchEventAttributes = {
  view: 'receiving' | 'inventory_adjustments' | 'shrinkage';
  searchQuery: string | undefined;
  resultCount: number | undefined;
  isSearchingByGtin: boolean;
  warehouseId: string;
  /**
   * Purchase order count is only relevant when search happens in receiving tool
   */
  purchaseOrderCount?: number;
};

type Options = {
  disabled?: boolean;
};

export function useWarehouseItemSearchEvent(
  attributes: WarehouseSearchEventAttributes,
  { disabled }: Options = {},
) {
  const { view, searchQuery, resultCount, isSearchingByGtin, warehouseId, purchaseOrderCount } =
    attributes;

  useEffect(() => {
    if (disabled || !searchQuery || resultCount === undefined) return;

    const attributes: EventAttributes = {
      results_count: resultCount,
      wm_venue_id: warehouseId,
    };

    if (purchaseOrderCount !== undefined) {
      attributes.purchase_order_count = purchaseOrderCount;
    }

    if (isSearchingByGtin) {
      attributes.barcode = searchQuery;
      addDataEvent(view, 'barcode_scan_results', attributes);
    } else {
      attributes.search_value = searchQuery;
      addDataEvent(view, 'search_results', attributes);
    }
  }, [
    view,
    searchQuery,
    resultCount,
    isSearchingByGtin,
    warehouseId,
    disabled,
    purchaseOrderCount,
  ]);
}
